var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[(_vm.dataLoaded)?_c('collapsable-sidebar',{attrs:{"list":_vm.list}}):_vm._e(),_c('router-view',{staticClass:"content-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }